export const RoleNames = {
    READER: 'READER',
    WRITER: 'WRITER',
    ARM_WRITER: 'ARM_WRITER',
    DCA_AGENCY: 'DCA_AGENCY',
    HOST: 'HOST',
    LOCAL_ADMIN: 'LOCAL_ADMIN',
}